import { S3Client, PutObjectCommand, DeleteObjectCommand } from "@aws-sdk/client-s3";
const AccessKeyId = process.env.REACT_APP_ACCESS_KEY_ID
const SecretAccessKey = process.env.REACT_APP_SECREATE_ACCESS_KEY
const Region = process.env.REACT_APP_REGION

var accessKeyId = AccessKeyId;
var secretAccessKey = SecretAccessKey;
var region = Region;  //Singapoor region by default

var bucketName = 'static-ethics';
const albumPhotosKey = "etm/";

// const CommonFileURL = "https://static-ethics.sgp1.digitaloceanspaces.com";   // privious common url for display images/files
const CommonFileURL = "https://static-ethics.sgp1.cdn.digitaloceanspaces.com";  // common url for display images/files
const FolderName = "etm";                                                       // main folder name (change according project)

const s3Client = new S3Client({
    region,
    endpoint: `https://${region}.digitaloceanspaces.com`,
    credentials: {
        accessKeyId,
        secretAccessKey
    },
    requestChecksumCalculation: "WHEN_REQUIRED"
});

export const CommonFileURLWithFolder = `${CommonFileURL}/${FolderName}/`;

export async function ImageUpload(pathdire, imagename, image) {
    let isUploaded = true;
    const photoKey = albumPhotosKey + pathdire + imagename;

    var params = {
        ACL: 'public-read',
        Bucket: bucketName,
        Key: photoKey,
        Body: image
    };
    await s3Client.send(new PutObjectCommand(params))
        .then(res => {
            console.log(`Upload succeeded - `, res?.$metadata?.httpStatusCode);
            isUploaded = true;
            return true;
        })
        .catch(err => {
            console.log("Upload failed:", err);
            isUploaded = false;
            return false;
        });

    return isUploaded;
}

export async function ImageDelete(imagePath) {
    let isDeleted = true;
    const photoKey = albumPhotosKey + imagePath;

    var params = {
        Bucket: bucketName,
        Key: photoKey
    };
    await s3Client.send(new DeleteObjectCommand(params))
        .then((data) => {
            console.log('sucessfully deleted ' + imagePath, data?.$metadata?.httpStatusCode)
            isDeleted = true;
        })
        .catch((err) => {
            console.log('err: ', err)
            isDeleted = false;
        });

    return isDeleted;
}
